import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const imageHighlightCardDefaultVariants = {}
const imageHighlightCardCompoundVariants = []

const imageHighlightCardSlotNames = [
  [
    "root",
    "image-highlight-card__root"
  ],
  [
    "imgWrapper",
    "image-highlight-card__imgWrapper"
  ],
  [
    "img",
    "image-highlight-card__img"
  ],
  [
    "contentWrapper",
    "image-highlight-card__contentWrapper"
  ],
  [
    "topContent",
    "image-highlight-card__topContent"
  ],
  [
    "title",
    "image-highlight-card__title"
  ],
  [
    "description",
    "image-highlight-card__description"
  ],
  [
    "bottomContent",
    "image-highlight-card__bottomContent"
  ],
  [
    "ctaDescription",
    "image-highlight-card__ctaDescription"
  ],
  [
    "ctaWrapper",
    "image-highlight-card__ctaWrapper"
  ]
]
const imageHighlightCardSlotFns = /* @__PURE__ */ imageHighlightCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, imageHighlightCardDefaultVariants, getSlotCompoundVariant(imageHighlightCardCompoundVariants, slotName))])

const imageHighlightCardFn = memo((props = {}) => {
  return Object.fromEntries(imageHighlightCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const imageHighlightCardVariantKeys = []
const getVariantProps = (variants) => ({ ...imageHighlightCardDefaultVariants, ...compact(variants) })

export const imageHighlightCard = /* @__PURE__ */ Object.assign(imageHighlightCardFn, {
  __recipe__: false,
  __name__: 'imageHighlightCard',
  raw: (props) => props,
  variantKeys: imageHighlightCardVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, imageHighlightCardVariantKeys)
  },
  getVariantProps
})